import React, { Component } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Row, Col, Container } from 'react-bootstrap';

export class MedGeneric extends Component {
    render() {
        const col1 = [
            "Acetaminophen", "Acyclovir", "Acetylsalicylic acid of 500mg", "Folic acid",
            "Valproic acid", "Sterile water", "Albendazole", "Alka Seltzer", "Alopurinol",
            "Coal tar + salicylic acid", "Ambroxol", "Amikacin", "Amoxicillin + Clavulanic Acid",
            "Amoxicillin", "Ampicillin", "Aspirin", "Azithromycin", "Sulfur and white petrolatum",
            "Bacillus Clausii", "Benzetacil", "Benzoyl peroxide", "Betamethasone + salicylic acid",
            "Betamethasone valerate", "Sodium bicarbonate", "Biperiden hydrochloride",
            "Fenoterol Hydrobromide", "Bromide", "Ipratropium Bromide", "Otilonium Bromide",
            "Vecuronium Bromide", "Budesonide", "Carbamazepine", "Caspofungin", "Cefadroxil",
            "Cephalothin", "Cefepime", "Cefixime", "Cefotaxime", "Ceftazidime", "Ceftriaxone",
            "Ciclosporin microemulsion", "Ciprofloxacin", "Clarithromycin", "Clindamycin",
            "Clobetasol propionate", "Chloramphenicol", "Chlorpheniramine maleate",
            "Metformin Hydrochloride", "Chloroquine phosphate", "Potassium chloride",
            "Sodium chloride", "Clotrimazole", "Colchicine", "Complex B"
        ];

        const col2 = [
            "Dexketoprofen trometamol", "Dextrose solution", "Dextrose and Sodium Chloride",
            "Diclofenac", "Dicloxacillin", "Diphenidol", "Dimenhydrinate", "Beclomethasone Dipropionate",
            "Dorival", "Doxycycline", "Epinephrine", "Ergotamine in association", "Erythromycin",
            "Esomeprazole", "Streptomycin sulfate", "Phenytoin sodium", "Fluconazole", "Gentamicin",
            "Glimepiride", "Hydrocortisone", "Hydroxychloroquine sulfate", "Aluminum Hydroxide, Magnesium",
            "Aminochelated iron + folic acid", "Iron saccharate or citrate", "Hyoscine", "Ibuprofen",
            "Ipratropium", "Itraconazole", "Ketoconazole", "Ketoprofen", "Lactobacillus Reuteri Protectis",
            "Lactulose", "Lansoprazole", "Leflunomide", "Levetiracetam", "Levofloxacin",
            "Lidocaine with epinephrine", "Magnesium sulfate", "Mamotrigine", "Metamizole Sodium",
            "Metronidazole", "Metronidazole + Nystatin", "Moxifloxacin", "Multivitamins",
            "Multivitamins for infusion", "Neomycin", "Nifedipine", "Nystatin", "Silver nitrate",
            "Nitrofurantoin", "Ofloxacin", "Oxcarbazepine", "Zinc oxide"
        ];

        const col3 = [
            "Zinc Oxide + Calamine", "Pyrantel Pamoate", "Pancrealipase", "Benzathine Penicillin G",
            "Procaine Penicillin G", "Sodium Penicillin G Crystalline", "Penicillins, among others",
            "Permethrin", "Phyllium plantago", "Piperacillin / Tazobactam", "Pyrimethamine / Sulfadoxine",
            "Polymyxin B", "Prednicarbate", "Prednisolone", "Pregabalin", "Prenatals",
            "Primaquine phosphate or diphosphate", "Propinoxate", "Ranitidine hydrochloride",
            "Ranitidine", "Riluzole", "Rupatadine fumarate", "Salbutamol", "Oral rehydration salts",
            "Secnidazole", "Simethicone", "Simitriptan", "Hartman solution", "Pediatric Solution No. 1",
            "Pediatric Solution No. 2", "Saline solution", "Bismuth subsalicylate", "Sucralfate",
            "Polyvalent antivenom serum", "Liquid oral serum", "Micronutrient Supplement", "Teclozan",
            "Thifecycline", "Timolol maleate", "Tinidazole", "Tobramycin", "Tobramycin/Dexamethasone",
            "Topiramate", "Tramadol Hydrochloride", "Trimethoprim – Sulfamethoxazole",
            "Vitamin 'A' pearl of 50,000 IU", "Vitamin A", "Vitamin B 12", "Vitamin B1",
            "Vitamin C", "Vitamin D", "Vitamin K", "Neurotropic Vitamins"
        ];

        return (
            <div>
                <Header />
                <Container className="fondo-texto py-4">
                    <Row className="mb-4 text-center">
                        <Col>
                            <h1>Generic Medications</h1>
                        </Col>
                    </Row>

                    <div className="mb-4">
                        <p className="lead">
                            <strong>Wholesale.</strong> Tablets, Syrup Jar, Suspension, Vial
                        </p>
                    </div>

                    <Row>
                        {[col1, col2, col3].map((column, index) => (
                            <Col key={index} sm={12} md={4}>
                                <ul className="list-unstyled">
                                    {column.map((item, i) => (
                                        <li key={i} className="small mb-1">• {item}</li>
                                    ))}
                                </ul>
                            </Col>
                        ))}
                    </Row>
                </Container>
                <Footer />
            </div>
        );
    }
}